import { connect } from 'react-redux';

import UserLogin from '../components/pages/user-login';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const UserLoginConnector = connect(mapStateToProps, {})(UserLogin);

export default UserLoginConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/user-login-connector.js
 **/